export default {
  webSitesList: [],
  webSelectedSites: []
};